import FollowArtist from './FollowArtist';

export default FollowArtist;
